import styled from 'styled-components';

import {
  CommonPacksPage,
  loader,
} from '@sorare/gameplay/src/components/commonGame/CommonPacksPage';

export { loader };

const Wrapper = styled.div`
  padding: var(--double-unit);
`;

const MobileCommonPacksPage = () => {
  return (
    <Wrapper>
      <CommonPacksPage />
    </Wrapper>
  );
};

export default MobileCommonPacksPage;
